import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
  selector: 'aux-investigator-forecast-update-modal',
  template: `
    <div class="w-[570px] font-inter">
      <div class="text-xl font-bold text-aux-blue-dark">Confirm Update to Investigator Budget</div>
      <section class="flex flex-col">
        <p class="my-7">
          Please confirm that you are changing your remaining investigator balance source to:
          <span class="font-bold">{{ ref.data?.source }}</span>
          .
        </p>
        <p>
          Saving this change will overwrite the remaining investigator balance on your existing
          budget.
        </p>
        <div class="mt-7 flex items-center justify-between border-t border-aux-gray-dark pt-3">
          <span class="cursor-pointer" (click)="ref.close()">No, Cancel</span>
          <aux-button
            variant="success"
            label="Update Investigator Budget"
            icon="Check"
            [classList]="'text-sm'"
            [onClick]="confirm"
          />
        </div>
      </section>
    </div>
  `,
})
export class InvestigatorForecastUpdateModalComponent {
  ref = inject(CustomOverlayRef<unknown, { source: string }>);

  confirm = () => {
    this.ref.close({ result: true });
  };
}
